import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

const PAINTER_DARK = '#252e3d'
const PAINTER_LIGHT_BG = '#f5f6f8'
const PAINTER_SECONDARY_TEXT = '#5d6678'
export const PAINTER_DIALOG_OVERLAY = 'rgba(37, 46, 61, 0.45)'

export const usePainterProfilePageStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: PAINTER_LIGHT_BG
  },
  header: {
    backgroundColor: PAINTER_DARK,
    height: 56,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1, 0, 0.5),
    flexShrink: 0
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  backBtn: { color: '#fff' },
  headerTitle: {
    color: '#fff',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 500
  },
  avatarBtn: {
    padding: 0,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '50%',
    marginRight: theme.spacing(1)
  },
  avatar: {
    width: 32,
    height: 32,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%'
  },
  content: {
    flex: 1,
    maxWidth: 680,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 2)
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 6,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(3)
  },
  sectionTitle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 600,
    color: PAINTER_DARK,
    marginBottom: theme.spacing(2)
  },
  avatarSection: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(3)
  },
  avatarUploadArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(4)
  },
  avatarLarge: {
    width: '80px !important',
    height: '80px !important',
    borderRadius: '50%',
    fontSize: `${theme.typography.pxToRem(28)} !important`,
    backgroundColor: theme.palette.primary.main
  },
  fieldGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    [theme.breakpoints.down('xs')]: { gridTemplateColumns: '1fr' }
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75)
  },
  label: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 500,
    color: PAINTER_SECONDARY_TEXT
  },
  input: {
    height: 44,
    padding: theme.spacing(0, 1.5),
    borderRadius: 6,
    border: '1px solid #d5d9e2',
    fontSize: theme.typography.pxToRem(14),
    outline: 'none',
    '&:focus': { borderColor: PAINTER_DARK }
  },
  secondaryActions: { marginTop: theme.spacing(3) },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3)
  },
  dialogBackdrop: {
    position: 'fixed',
    inset: 0,
    backgroundColor: PAINTER_DIALOG_OVERLAY,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    zIndex: 1300
  },
  dialog: {
    width: '100%',
    maxWidth: 420,
    backgroundColor: '#fff',
    borderRadius: 6,
    boxShadow: theme.shadows[8],
    padding: theme.spacing(3)
  },
  dialogTitle: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 600,
    color: PAINTER_DARK,
    marginBottom: theme.spacing(1.5)
  },
  dialogText: {
    fontSize: theme.typography.pxToRem(14),
    color: PAINTER_SECONDARY_TEXT,
    marginBottom: theme.spacing(3)
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1)
  }
}))
